import React from "react";
import {Modal, Row} from "antd";
import IWidgetProps from "../../../../model/interface/widget/IWidgetProps";
import IWidgetPropsFunctions from "../../../../model/interface/widget/IWidgetPropsFunctions";
import IWidget from "../../../../model/interface/widget/IWidget";
import IPopupOptions from "../../../../model/interface/widget/option/IPopupOptions";
import ICardWidgetPropsFunctions from "../../../../model/interface/dataStorage/card/ICardWidgetPropsFunctions";
import FieldsService from "../../../../model/service/dataStorage/FieldsService";
import Utils from "../../../../utils";
import Button from "../../../shared/button/Button";
import {IAppState} from "../../../../redux/store";
import selectors from "../../../../redux/selectors";
import {connect} from "react-redux";
import WidgetChildren from "./WidgetChildren";
import LocaleText from "../../settings/dictionary/LocaleText";
import IconBuilder from "../../../../utils/IconBuilder";

interface IState {
    show: boolean
    seenChangedFields: string[]
}

interface IProps extends IWidgetProps<IWidgetPropsFunctions<IWidget<IPopupOptions>>, IPopupOptions> {
    getText: (code: string, fallBack?: string) => string
}

class PopupWidget extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        const show = props.options.trigger ? {
            auto: true,
            action: false,
            alertChangeField: this.hasFieldsContentBeenChanged(),
            button: false,
            default: true
        }[props.options.trigger] : true
        this.state = {
            show: show === undefined ? true : show,
            seenChangedFields: []
        }
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {

    }

    onClick = () => {
        this.props.options.trigger === 'alertChangeField' && this.triggerChangeSeen()
        this.setState({show: false})
    }


    triggerChangeSeen() {
        const {functions, resource} = this.props
        if (resource && this.hasFieldsContentBeenChanged() && 'getContentType' in functions) {
            const contentType = (functions as ICardWidgetPropsFunctions).getContentType()
            this.getContentChangedFields().forEach((name) => {
                const field = contentType.fields.find(f => f.name === name)
                if (field?.id && resource.id) {
                    FieldsService.seenChangeLog(field.id, resource.id)
                    this.setState(state => ({seenChangedFields: [...state.seenChangedFields, field.name]}))
                }
            })

        }
    }

    hasFieldsContentBeenChanged = () => {
        const {resource, options} = this.props
        return options.alertChangeFields?.some((f: string) => resource?._unseenChangedFields?.includes(f) && (!this.state || !this.state.seenChangedFields.includes(f)))
    }

    getContentChangedFields(): string[] {
        const {resource, options} = this.props
        return options.alertChangeFields?.filter((f: string) => resource?._unseenChangedFields?.includes(f)) || []
    }

    render() {
        const {options, getText} = this.props
        const {show} = this.state
        return (
            <>
                {options.trigger === 'button' && options.triggerButton?.label && (
                    <Button
                        type={options.triggerButton.type}
                        danger={Utils.toBoolean(options.triggerButton.danger)}
                        onClick={() => this.setState({show: true})}
                        style={{background: options.triggerButton.color, color: options.triggerButton.textColor}}
                        icon={options.triggerButton.icon ? IconBuilder(options.triggerButton.icon) : undefined}
                        size={options.triggerButton.size || "small"}
                    >
                        {typeof options.triggerButton.label === 'string' ? getText(options.triggerButton.label || '') : options.triggerButton.label}
                    </Button>
                )}
                <Modal visible={show} title={<LocaleText code={options.title || ''}/>} closable={options.closable === true} maskClosable={options.closable === true}
                       destroyOnClose={true} onCancel={() => this.setState({show: false})}
                       footer={options.confirmButton?.label ? <Row justify={'end'}>
                           <Button
                               type={options.confirmButton.type}
                               danger={Utils.toBoolean(options.confirmButton.danger)}
                               onClick={() => this.onClick()}
                               style={{background: options.confirmButton.color, color: options.confirmButton.textColor}}
                               icon={options.confirmButton.icon ? IconBuilder(options.confirmButton.icon) : undefined}
                               size={options.confirmButton.size || "small"}
                           >
                               {typeof options.confirmButton.label === 'string' ? getText(options.confirmButton.label || '') : options.confirmButton.label}
                           </Button>
                       </Row> : false}>
                    <WidgetChildren {...this.props}/>
                </Modal>
            </>

        );
    }
}


const mapStateToProps = (state: IAppState) => {

    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    }
}

export default connect(mapStateToProps)(PopupWidget)